export const Container = ({ children }) => (
  <div className="container">
    {children}
  </div>
);